import React, { useState, useEffect, useCallback } from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import buxferTransactions from '../services/buxfer.service';
// debounce used for suggestion API calls (temporarily disabled)
// import debounce from 'lodash.debounce';

const DEFAULT_PAGE_SIZE = 10;

export default function BuxferTransactionSmartSearch({ inputValue: controlledInputValue, onSelect, onSearchInputChange }) {
  const [inputValue, setInputValue] = useState(controlledInputValue || '');
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  // Autocomplete defaults (disabled):
  // To re-enable autocomplete suggestions, uncomment fetchDefault and related calls.
  const fetchDefault = useCallback(async () => {
    // intentionally no-op while autocomplete is disabled to avoid API calls while typing
    setOptions([]);
  }, []);

  // Autocomplete suggestions (disabled):
  // To re-enable, restore the debounce import and this function which calls
  // buxferTransactions.searchTransactions(keyword) and sets options.
  const fetchSuggestions = useCallback(
    async (keyword) => {
      // intentionally no-op while autocomplete is disabled
      return;
    },
    []
  );

  useEffect(() => {
    if (controlledInputValue !== undefined) {
      setInputValue(controlledInputValue);
    }
  }, [controlledInputValue]);

  useEffect(() => {
    // Autocomplete is temporarily disabled to prevent API calls while typing.
    // We still keep the inputValue state so Enter/Search button works.
    if (!inputValue.trim()) {
      fetchDefault();
    } else {
      // fetchSuggestions would run here when re-enabled
      // fetchSuggestions(inputValue);
    }
    // no cleanup needed since debounce is disabled
  }, [inputValue, fetchDefault, fetchSuggestions]);

  const handleInputChange = (event, newInputValue, reason) => {
    if (reason === 'clear') {
      setInputValue('');
      onSearchInputChange('')
      fetchDefault();
    } else {
      setInputValue(newInputValue);
      onSearchInputChange(newInputValue)
    }
  };

  const handleChange = (event, newValue) => {
    if (!newValue) {
      setInputValue('');
      fetchDefault();
      return;
    }
    const chosenLabel = typeof newValue === 'string' ? newValue : newValue.label;
    setInputValue(chosenLabel);
    if (onSelect) {
      onSelect(chosenLabel);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && onSelect) {
      onSelect(inputValue);
    }
  };

  return (
    <Autocomplete
      freeSolo
      options={options}
      getOptionLabel={(opt) => opt.label || ''}
      filterOptions={(x) => x}
      loading={loading}
      inputValue={inputValue}
      onInputChange={handleInputChange}
      onChange={handleChange}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Search"
          variant="outlined"
          style={{ width: 200 }}
          onKeyDown={handleKeyDown}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading && <CircularProgress size={20} />}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
}
